// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as RnrParamsContext from "../utils/version/RnrParamsContext.bs.js";
import * as RnrPromoBannerCmp from "./RnrPromoBannerCmp.bs.js";
import * as RnrLendingBannerCmp from "./RnrLendingBannerCmp.bs.js";

function getBanner(banners, uuid, lang, version) {
  return List.mapi((function (index, banner) {
                var match = banner.name;
                if (match === "ASSUREKIT_INSURANCE") {
                  return React.createElement(RnrPromoBannerCmp.make, {
                              banner: banner,
                              uuid: uuid,
                              lang: lang,
                              version: version,
                              key: String(index)
                            });
                } else {
                  return React.createElement(RnrLendingBannerCmp.make, {
                              banner: banner,
                              uuid: uuid,
                              lang: lang,
                              version: version,
                              key: String(index)
                            });
                }
              }), List.filter(function (banner) {
                    return List.mem(banner.name, {
                                hd: "ASSUREKIT_INSURANCE",
                                tl: {
                                  hd: "LENDING_LANDING_PAGE",
                                  tl: /* [] */0
                                }
                              });
                  })(banners));
}

function getBanners(banners, rnr_2w_uuid) {
  var match = RnrParamsContext.getRnrParams(undefined);
  var lang = match.lang;
  var uuid = match.uuid;
  var version = match.version;
  if (typeof banners === "number") {
    return /* [] */0;
  }
  if (banners.TAG !== /* Live */1) {
    return /* [] */0;
  }
  var banner_list = banners._0;
  if (uuid === "") {
    return getBanner(banner_list, rnr_2w_uuid, lang, version);
  } else {
    return getBanner(banner_list, uuid, lang, version);
  }
}

export {
  getBanner ,
  getBanners ,
  
}
/* react Not a pure module */
